import { AppItem, NoticeItem } from '@/model/definitions'

export const appData: AppItem[] = [
  {
    id: 1,
    appName: '研发工具导航',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E5%8D%87%E5%AD%A6%E8%A7%84%E5%88%92%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: '/guide',
    techOnly: true
  },
  {
    id: 2,
    appName: '班主任工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E7%8F%AD%E4%B8%BB%E4%BB%BB%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-class-manager/'
  },
  {
    id: 3,
    appName: '市场工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E5%B8%82%E5%9C%BA%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-market-admin/'
  },
  {
    id: 4,
    appName: '教师管理工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E6%95%99%E5%B8%88%E7%AE%A1%E7%90%86%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/enterprise-teacher-management/'
  },
  {
    id: 5,
    appName: '财务工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E8%B4%A2%E5%8A%A1%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/enterprise-finance-admin/'
  },
  {
    id: 6,
    appName: '教研管理工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E6%95%99%E7%A0%94%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-question-bank/'
  },
  {
    id: 7,
    appName: '教务工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E6%95%99%E5%8A%A1%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-teaching-affair-admin/'
  },
  {
    id: 8,
    appName: '教学工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E6%95%99%E5%AD%A6%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-teach-work-bench/'
  },
  {
    id: 9,
    appName: '学生档案工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E5%AD%A6%E7%94%9F%E6%A1%A3%E6%A1%88%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/enterprise-student-info/'
  },
  {
    id: 10,
    appName: '留学工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E5%8D%87%E5%AD%A6%E8%A7%84%E5%88%92%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-advancement-plan-admin/'
  },
  {
    id: 11,
    appName: '销售工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E9%94%80%E5%94%AE%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/enterprise-sales-admin/'
  },
  {
    id: 12,
    appName: '商品管理工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E5%95%86%E5%93%81%E7%AE%A1%E7%90%86%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-commodity-admin/'
  },
  {
    id: 13,
    appName: '产品经理工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E4%BA%A7%E5%93%81%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-teach-product-admin/'
  },
  {
    id: 14,
    appName: '人事权限工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E4%BA%BA%E4%BA%8B%E6%9D%83%E9%99%90%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/enterprise-human-resource/'
  },
  {
    id: 15,
    appName: '质检工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E8%B4%A8%E6%A3%80%E5%B7%A5%E4%BD%9C%E5%8F%B0.png',
    link: 'visioneschool.com/study-quality-control-admin/'
  },
  {
    id: 24,
    appName: '高端项目管理平台',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/98e9/df14/0ae0/663a78a4-0ea0-41fd-9e89-9a0dc27fa685',
    link: 'visioneschool.com/hbas-admin/'
  },
  {
    id: 16,
    appName: '用户中心工作台',
    avatarUrl: 'https://va-pics.oss-cn-hangzhou.aliyuncs.com/H5/%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83.png',
    link: 'visioneschool.com/enterprise-userCenter-work-bench/'
  },
  // {
  //   id: 17,
  //   appName: 'OSS管理平台',
  //   avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/e40b/3134/21e9/4b43949a-9e12-4313-b04e-8ff17619c0e6',
  //   link: 'visioneschool.com/oss-platform/',
  //   techOnly: true
  // },
  {
    id: 18,
    appName: '数据中心',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/7389/cbf4/e86f/7252e01a-f68e-4fbc-9837-3b27c7a0796f',
    link: '/data-center',
    techOnly: true
  },
  // {
  //   id: 19,
  //   appName: '项目治理平台',
  //   avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/075b/a894/2932/504411c0-2392-498a-b570-3c9fa10644ec',
  //   link: 'visioneschool.com/pm-platform/'
  // },
  {
    id: 20,
    appName: '工单系统',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/cd18/a144/885a/5b226aac-a588-441a-81dc-9f983b653219',
    link: 'https://workflow.visioneschool.com/'
  },
  {
    id: 21,
    appName: 'APP下载中心',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/497a/08d4/e842/4731d908-248e-4d80-a794-999f9c693fe5',
    link: 'https://www.visioneschool.com/download/'
  },
  // {
  //   id: 22,
  //   appName: 'BI调度系统',
  //   avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/5739/b3c4/7912/8e8cf870-2197-4c3b-9375-e8e5efd32664',
  //   link: 'http://ds.datacenter.visioneschool.com/dolphinscheduler'
  // },
  {
    id: 23,
    appName: '唯寻DT',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/f8ab/6df4/0a39/f1c2163b-93a0-4fd6-ba8f-587578a48fb6',
    link: 'http://bi.datacenter.visioneschool.com'
  },
  {
    id: 24,
    appName: '业绩实时大屏',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/90aa/51a4/9c61/bef90ad9-16c9-4a15-aa09-c78ea8967a94',
    link: 'visioneschool.com/vision-data-platform/'
  },
  {
    id: 25,
    appName: '合同管理系统',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/6c1a/4b24/94a0/cd39c2d8-0a49-42b4-a1c6-916304982e43',
    link: 'visioneschool.com/contract-management-admin/'
  },
  {
    id: 26,
    appName: '微伴系统',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/53aa/b5b4/8a1a/b8422cf5-a1a8-4b5b-aa35-cb2139e58f72.jpg',
    link: 'https://wxwork.visioneschool.com/dashboard',
    env: 'pro'
  },
  {
    id: 27,
    appName: '微伴系统(测试)',
    avatarUrl: 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/53aa/b5b4/8a1a/b8422cf5-a1a8-4b5b-aa35-cb2139e58f72.jpg',
    link: 'http://test-wxwork.visioneschool.com',
    env: 'uat'
  }
]

export const words = [
  '对于攀登者来说，失掉往昔的足迹并不可惜，迷失了继续前时的方向却很危险。',
  '人生是各种不同的变故、循环不已的痛苦和欢乐组成的。那种永远不变的蓝天只存在于心灵中间，向现实的人生去要求未免是奢望。',
  '你是你人生的作者，何必把剧本写得苦不堪言。',
  '有些路很远，走下去会很累，可是不走会后悔。',
  '环境不会改变，解决之道在于改变自己。',
  '真正的价值并不在人生的舞台上，而在我们扮演的角色中。',
  '不是每个人都能成为，自己想要的样子，但每个人，都可以努力，成为自己想要的样子。相信自己，你能作茧自缚，就能破茧成蝶。',
  '世上没有绝望的处境，只有对处境绝望的人。',
  '多要求自己，你会更加独立；少要求别人，你会减少失望。',
  '梦想，可以天花乱坠，理想，是我们一步一个脚印踩出来的坎坷道路。',
  '生命是一段精彩旅程，要活的有自己的样子，而不是别人的影子。',
  '再长的路，一步步也能走完，再短的路，不迈开双脚也无法到达。',
  '欲望以提升热忱，毅力以磨平高山。',
  '寻找理想，理想就在追求的路上，前方是否真的光亮，且看勇气壮不壮，面对困难的波浪，只有迎上，才会领略到成长的力量。',
  '真正的强者，不是没有眼泪的人，而是含着眼泪奔跑的人。',
  '志在峰巅的攀登者，不会陶醉在沿途的某个脚印之中。',
  '人生不是坐等风雨过去，而是学会雨中起舞',
  '自己打败自己是最可悲的失败，自己战胜自己是最可贵的胜利。',
  '莫找借口失败，只找理由成功。',
  '“要变得温柔和强大，就算哪天突然孤身一人， 也能平静地活下去，不至于崩溃。”',
  '人生就有许多这样的奇迹，看似比登天还难的事，有时轻而易举就可以做到，其中的差别就在于非凡的信念。',
  '失败是什么?没有什么，只是更走近成功一步;成功是什么?就是走过了所有通向失败的路，只剩下1条路，那就是成功的路。',
  '有了坚强的理由，一切顺风顺水，虚伪的懦弱，也会在真诚的诺言面前，显得苍白无力，无所适从。所以，坚强也就成了你人生中一道靓丽的风景！',
  '人生伟业的建立，不在能知，乃在能行。',
  '好心不一定会换来感恩，但千万不要因此而灰心。'
]

export const notice: NoticeItem[] = [
  {
    id: 1,
    title: '唯寻学堂：',
    notice: [{ txt: '建议钉钉工作台直接登录使用更快捷。' }],
    date: '2022-09-05'
  },
  {
    id: 2,
    title: 'EHR【员工自助】功能说明：',
    notice: [
      { title: '离职申请：', txt: '个人提交离职申请；' },
      { title: '信息变更：', txt: '包含银行卡信息、教育信息、户籍及住址信息的变更申请，完善子女信息可依据政策享有育儿假；' },
      { title: '政策制度：', txt: '可以查询公司分享的部分政策制度。如考勤制度、员工手册、工服管理办法；' },
      { title: 'EHR登录密码：', txt: '首次登陆或忘记密码，需要点击【忘记密码】进行设置；' },
      { title: '工资单：', txt: '仅手机端可查询，点击【唯寻EHR-我的薪酬】，工资单密码首次登录也需要【忘记密码】进行初始化设置；如未来忘记密码，需自行邮件找回，尝试超过5次失败，锁定1小时后自行解锁；薪资数据查看生效日后的15天内可见；' }
    ],
    date: '2022-10-28'
  },
  {
    id: 3,
    title: 'HR问题咨询对接人：',
    notice: [
      { title: '部门HRBP：   ', txt: '员工试用期管理、离职管理及部门问题咨询。' },
      { title: '分校HR/HRBP：', txt: '分校员工考勤问题答疑审批、试用期管理、离职管理及分校问题咨询。' },
      { title: '黄丽华：     ', txt: '每月MOKA考勤，员工合同协议及档案管理，离职证明开具。' },
      { title: '李晓骅：     ', txt: '在职/收入证明咨询开具，五险一金、课酬答疑及留学生落户咨询' },
      { title: '所  迪：     ', txt: '薪资咨询，EHR异常问题解决。' }
    ],
    date: '2022-10-28'
  }
]
